module.exports = __webpack_public_path__ + "static/media/instrument.462a9a52.svg";